import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import { headingsSchema } from '../Header';
import FundCodesTable from './FundCodesTable';

export const FundCodesTableSchema: JSONSchema7 = {
    title: 'Fund Codes Table',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            description: 'A stylesheet',
            default: '',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        id: {
            type: 'string',
            description: 'Tabel Id',
        },
        titles: headingsSchema,
        columns: {
            type: 'array',
            title: 'Add columns',
            items: {
                type: 'object',
                properties: {
                    label: { type: 'string', title: 'Column header' },
                    value: { type: 'string', title: 'Column data key' },
                    hasChildColumns: {
                        type: 'boolean',
                        title: 'Add child columns',
                        default: false,
                    },
                },
                dependencies: {
                    hasChildColumns: {
                        oneOf: [
                            {
                                properties: {
                                    hasChildColumns: { enum: [true] },
                                    childColumns: {
                                        type: 'array',
                                        title: 'Child columns',
                                        items: {
                                            type: 'object',
                                            properties: {
                                                label: {
                                                    type: 'string',
                                                    title: 'Column header text',
                                                },
                                                value: { type: 'string', title: 'Column data key' },
                                            },
                                        },
                                    },
                                },
                            },
                            {
                                properties: {
                                    hasChildColumns: { enum: [false] },
                                },
                            },
                        ],
                    },
                },
            },
        },
        productGroup: {
            type: 'object',
            title: 'Rows(Product Group) options',
            properties: {
                dataKey: {
                    type: 'string',
                    title: 'Data Key',
                    description: 'json path for product group array',
                },
                groupDataKey: {
                    type: 'string',
                    title: 'Group data Key',
                    description: 'json path in product group array',
                },
                fundDataKey: {
                    type: 'string',
                    title: 'Fund data key',
                    description: 'json path in product group array',
                },
            },
        },
        transformRowsData: {
            type: 'boolean',
            title: 'Transform Rows Data',
            default: false,
        },
    },
    dependencies: {
        transformRowsData: {
            oneOf: [
                {
                    properties: {
                        transformRowsData: { enum: [true] },
                        functionToTransformRows: {
                            type: 'string',
                            description: 'Function to transform Rows',
                            default: 'return (data) => { return data}',
                        },
                    },
                },
                {
                    properties: {
                        transformRowsData: { enum: [false] },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

export const fundCodesTableSchemaGroups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['id', 'titles', 'columns', 'productGroup'],
        'Transform Data': ['transformRowsData', 'functionToTransformRows'],
    },
];

const FundCodesTableWidget: commonTypes.IWidget = {
    schema: FundCodesTableSchema,
    uiSchema: {
        'ui:groups': fundCodesTableSchemaGroups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        id: {
            'ui:widget': 'CustomTextInput',
        },
        titles: {
            items: {
                headerText: {
                    'ui:widget': 'ResourcePicker',
                },
            },
        },
        columns: {
            items: {
                label: {
                    'ui:widget': 'ResourcePicker',
                },
                value: {
                    'ui:widget': 'CustomTextInput',
                },
                hasChildColumns: {
                    'ui:widget': 'CustomCheckbox',
                },
                childColumns: {
                    items: {
                        label: {
                            'ui:widget': 'ResourcePicker',
                        },
                        value: {
                            'ui:widget': 'CustomTextInput',
                        },
                    },
                },
            },
        },
        productGroup: {
            dataKey: {
                'ui:widget': 'CustomTextInput',
            },
            groupDataKey: {
                'ui:widget': 'CustomTextInput',
            },
            fundDataKey: {
                'ui:widget': 'CustomTextInput',
            },
        },
        functionToTransformRows: { 'ui:widget': 'JSEditor' },
    },
    templateView: FundCodesTable,
    id: 'FundCodesTable',
    group: 'table',
    contentPlaceHolders: ['children'],
    initialData: () => ({}),
};

export default FundCodesTableWidget;
